export function addVariantToCart($id, $quantity = 1, $properties) {
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
  let config = fetchConfig('javascript');

  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  let formData = new FormData();

  formData.append('id', $id);
  formData.append('quantity', $quantity);

  if ($properties) {
    for (let key in $properties) {
      if ($properties.hasOwnProperty(key)) {
        formData.append('properties[' + key + ']', $properties[key]);
      }
    }
  }

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`,config)
    .then(response => {
      if (response.status !== 200) {
        productFormError(response);

        throw new Error("HTTP status " + response.status);
      }

      return response.json();
    })
    .then(response => {
      cart.renderContents(response);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function productFormError(response) {
  let productSubmit = document.querySelectorAll('.product-submit');

  productSubmit.forEach((submit) => {
    let html = `<span class="error"><strong>${response.description}</strong></span>`

    submit.innerHTML = submit.innerHTML + html;
  });
}